export var NameSpace = {
  miniMobile: "xsmall",
  mobile: "small",
  tablet: "tablet",
  desktop1200: "desktop1200",
  desktop1400: "desktop1400",
  desktop1900: "desktop1900",
};
